import React, { useState } from 'react';

import { TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, Box } from '@mui/material';
import { Form, Formik } from 'formik';

import axios from '../modules/axios';

export default ({ children, title, from, to, subject, text, date, ...props }) => {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);

  const sendEmail = values => {
    axios
      .post('leon_stockmail', {
        subject: values.subject,
        to: values.to,
        message: values.text,
        headers: `From: ${values.from}`,
        date_envoie: values.date || Date.now(),
        nbrelance: 0,
      })
      .then(res => {
        setSent(true);
      });
  };

  return (
    <React.Fragment>
      {children ? (
        <span onClick={() => setOpen(true)}>{children}</span>
      ) : (
        <Button variant='contained' color='primary' onClick={() => setOpen(true)}>
          Email
        </Button>
      )}
      <Dialog fullWidth={true} open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{title ?? 'Envoyer email'}</DialogTitle>

        <Formik
          initialValues={{ to, subject, text, date: new Date(), from: 'admin@immobilier-neuf.fr' }}
          onSubmit={values => sendEmail(values)}
        >
          {({ values, handleChange, handleSubmit, setFieldValue, setValues }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent>
                <Box p={1}>
                  <TextField
                    label='Destinaire(s)'
                    name='to'
                    value={values.to}
                    fullWidth
                    variant='outlined'
                    size='small'
                    onChange={handleChange}
                  />
                </Box>
                <Box p={1}>
                  <TextField
                    label='Expéditeur'
                    name='from'
                    value={values.from}
                    fullWidth
                    variant='outlined'
                    size='small'
                    onChange={handleChange}
                  />
                </Box>
                <Box p={1}>
                  <TextField
                    label='Objet'
                    name='subject'
                    value={values.subject}
                    fullWidth
                    variant='outlined'
                    size='small'
                    onChange={handleChange}
                  />
                </Box>
                <Box p={1}>
                  <TextField
                    label='Message'
                    name='text'
                    value={values.text}
                    multiline
                    fullWidth
                    variant='outlined'
                    size='small'
                    minRows='3'
                    onChange={handleChange}
                  />
                </Box>
                <Box p={1}>
                  <TextField
                    label="Date d'envoie"
                    name='date'
                    value={values.date}
                    fullWidth
                    variant='outlined'
                    size='small'
                    type='date'
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpen(false)}>Annuler</Button>
                {sent ? (
                  <div>Envoyé</div>
                ) : (
                  <Button type='submit' color='primary'>
                    Envoyer
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </React.Fragment>
  );
};
